import Card from 'react-bootstrap/Card';
import './insight-card-style.scss';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { useAppContext } from '../../../../common/context';
import { getInsightTabPath } from '../../../../common/utils';

function InsightItemCard(props) {
  const { data,isPagination } = props
  const {insightTab} = useAppContext();
  const insightPath = getInsightTabPath(insightTab);
  
  const cardBanner = card => card.banner ? card.banner : '/images/insights/insight-card-thumb.png';
  return (
    <Row className={isPagination ? 'insight-page-container':'insight-items-container'}>
      {data && Array.isArray(data) && data.map((card) => (
        <Col className="insight-item" key={card.title} md={4} sm={12}>
          <Link to={card?.byPass ?  card?.byPass : "/"+insightPath+ card.slug} className='link-hover'>
            <Card className='insight-item-card story-list-image w-100'>
              <div className="insight-card-benner-conatiner">
                <Card.Img variant="top" onContextMenu={(e) => e.preventDefault()} src={cardBanner(card)} className='insight-card-benner' />
              </div>

              <Card.Body className='p-0 insight-card-body'>
                <Card.Title className='article-cart-title'>{card.eyebrowText || ""}</Card.Title>
                <Card.Text className='article-cart-text'>
                  {card.title || ""}
                </Card.Text>
              </Card.Body>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  )
}
export default InsightItemCard;